module.exports = __webpack_public_path__ + "static/img/16.325f7e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/16.png
// module id = AXHY
// module chunks = 0